import { AbstractControl, FormGroup } from '@angular/forms';
import * as moment from 'moment';
import { DATE_REGEX_DASH } from './data-helper.factory';
export class DataValidator {
    static dateValidator2(AC: AbstractControl): any {
        if (AC && AC.value && !moment(AC.value, 'DD/MM/YYYY', true).isValid()) {
            const invalidObj = { dateValidator: true };
            return invalidObj;
        }

        return null;
    }

    static dateValidator(AC: AbstractControl): any {
        if (AC && AC.value) {
            const dateStr = AC.value;
            // Length of months (will update for leap years)
            const monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
            // Object to return if date is invalid
            const invalidObj = { dateValidator: true };

            // First check for m/d/yyyy or mm/dd/yyyy format
            // If the pattern is wrong, don't validate dates yet
            // if (!DATE_REGEX.test(dateStr)) {
            //   return null;
            // }

            // Parse the date input to integers based on mm/dd/yyyy format
            // const parts = dateStr.split('/');
            // const month = parseInt(parts[0], 10);
            // const day = parseInt(parts[1], 10);
            // const year = parseInt(parts[2], 10);

            // Parse the date input to integers based on yyyy-mm-dd format
            const parts = dateStr.split('-');
            const year = parseInt(parts[0], 10);
            const month = parseInt(parts[1], 10);
            const day = parseInt(parts[2], 10);

            // Make sure date is in range
            if (year < 2000 || year > 3000 || month === 0 || month > 12) {
                return invalidObj;
            }
            // Adjust for leap years
            if (year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0)) {
                monthLength[1] = 29;
            }
            // Check the range of the day
            if (!(day > 0 && day <= monthLength[month - 1])) {
                return invalidObj;
            }

            //TODO: check date min and max for each control by passing parameters
            // Check min and max date for receive date
            if (AC.parent.controls['receiveDate'] !== null && AC.parent.controls['receiveDate'] !== undefined) {
                const currentdate = new Date();
                const minReceiveDate = new Date();
                minReceiveDate.setMonth(minReceiveDate.getMonth() - 3);

                const min = moment(minReceiveDate).format('YYYY-MM-DD');
                const max = moment(currentdate).format('YYYY-MM-DD');

                if (moment(dateStr).isAfter(max) || moment(dateStr).isBefore(min)) {
                    return invalidObj;
                }
            }
        }

        return null;
    }

    static dateValidator3(AC: AbstractControl): any {
        if (AC && AC.value) {
            const dateStr = AC.value;
            // Length of months (will update for leap years)
            const monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
            // Object to return if date is invalid
            const invalidObj = { dateValidator: true };

            // First check for m/d/yyyy or mm/dd/yyyy format
            // If the pattern is wrong, don't validate dates yet
            // if (!DATE_REGEX.test(dateStr)) {
            //   return null;
            // }

            // Parse the date input to integers based on mm/dd/yyyy format
            // const parts = dateStr.split('/');
            // const month = parseInt(parts[0], 10);
            // const day = parseInt(parts[1], 10);
            // const year = parseInt(parts[2], 10);

            // Parse the date input to integers based on yyyy-mm-dd format
            const parts = dateStr.split('-');
            const year = parseInt(parts[0], 10);
            const month = parseInt(parts[1], 10);
            const day = parseInt(parts[2], 10);

            // Make sure date is in range
            if (year < 2000 || year > 3000 || month === 0 || month > 12) {
                return invalidObj;
            }
            // Adjust for leap years
            if (year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0)) {
                monthLength[1] = 29;
            }
            // Check the range of the day
            if (!(day > 0 && day <= monthLength[month - 1])) {
                return invalidObj;
            }
        }

        return null;
    }

    static dateValidatorSf(AC: AbstractControl): any {
        if (AC && AC.value) {
            const dateStr = AC.value;
            // Length of months (will update for leap years)
            const monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
            // Object to return if date is invalid
            const invalidObj = { dateValidator: true };

            // First check for m/d/yyyy or mm/dd/yyyy format
            //If the pattern is wrong, don't validate dates yet
            if (!DATE_REGEX_DASH.test(dateStr)) {
                return null;
            }

            // Parse the date input to integers based on mm/dd/yyyy format
            // const parts = dateStr.split('/');
            // const month = parseInt(parts[0], 10);
            // const day = parseInt(parts[1], 10);
            // const year = parseInt(parts[2], 10);

            let convertedDateStr: string;
            if (dateStr.includes('Time')) {
                convertedDateStr = moment(dateStr).format('YYYY-MM-DD');
            } else {
                convertedDateStr = dateStr;
            }

            // Parse the date input to integers based on yyyy-mm-dd format
            const parts = convertedDateStr.split('-');
            const year = parseInt(parts[0], 10);
            const month = parseInt(parts[1], 10);
            const day = parseInt(parts[2], 10);

            // Make sure date is in range
            if (year < 2000 || year > 3000 || month === 0 || month > 12) {
                return invalidObj;
            }
            // Adjust for leap years
            if (year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0)) {
                monthLength[1] = 29;
            }
            // Check the range of the day
            if (!(day > 0 && day <= monthLength[month - 1])) {
                return invalidObj;
            }
        }

        return null;
    }

    datesValidator2(date1: any, date2: any): { [key: string]: any } | null {
        return (group: FormGroup): { [key: string]: any } | null => {
            const start = group.controls[date1].value;
            const end = group.controls[date2].value;
            const datum1 = moment(start).startOf('day');
            const datum2 = moment(end).startOf('day');
            if (moment(datum1).isSameOrAfter(datum2)) {
                return { dateValidator: false };
            }
            return null; // period is ok, return null
        };
    }
}
